/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-04 22:22:20
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { modalFactory } from 'src/util/vueExtend';
import OrganizationConfigApi from './api/organizationConfigApi';
import { Toast } from 'src/util/toast';
import { createNamespace } from 'src/util/bem';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import { Integer } from 'src/types/base';

export namespace AddStationVOI {
    export interface PropsI {
        id?: number;
        parentId?: number;
        isPlatform?: boolean;

        saveSuccess?(): void;

        cancel?(): void;
    }
}

@Component
class AddStationModal extends Vue.Component<AddStationVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;
    @Prop({
        type: Number,
    })
    parentId!: number;

    @Prop({
        type: Boolean,
    })
    isPlatform!: false;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    data: any = [];
    target: number[] = [];
    saas: Integer = null

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        let { code } = await OrganizationConfigApi.saveOrganizationStation(this.id, this.target);
        if (code === 0) {
            Toast.success('新增组织成功！');
            this.saveSuccess();
            this.closeModal();
        }
    }
    async mounted() {
        this.queryOrganizationStation();
    }
    async queryOrganizationStation() {
        let { code, data } = await OrganizationConfigApi.queryOrganizationStation(this.id);
        if (code === 0) {
            this.data = data.map(i => ({ key: i.device_id, label: i.device_name }));
            this.target = data.filter(i => i.select === 1).map(i => i.device_id);
        }
    }
    async inherit() {
        let { code, data } = await OrganizationConfigApi.inheritOrganizationStation(this.id);
        if (code === 0) {
            this.target = data.map(i => i.device_id);
        }
    }
    async saasChange(v) {
        let { code, data } = await OrganizationConfigApi.querySysOrganizationStation(this.id, v);
        if (code === 0) {
            this.data = data.map(i => ({ key: i.device_id, label: i.device_name }));
            this.target = data.filter(i => i.select === 1).map(i => i.device_id);
        }
    }
    render(h) {
        return (
            <Modal title="添加站点" width="820" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form
                    class={createNamespace('mt20')}
                    ref="formValidate"
                    labelWidth={100}
                >
                    <form-item v-if={this.isPlatform} label="saas账号" prop="name" style="width:300px;display:inline-block;">
                        <EntitySelect type={EnumEntity.Saas.getId()} on-change={this.saasChange.bind(this)} v-model={this.saas}/>
                    </form-item>
                    <form-item label="" labelWidth={20}   style="width:300px;display:inline-block;">
                        <Button type="primary" on-click={this.inherit.bind(this)} class={createNamespace('mb10')}>
                            继承上级组织站点
                        </Button>{' '}
                    </form-item>
                </i-form>

                <transfer
                    list-style={{ width: '350px', height: '500px' }}
                    data={this.data}
                    target-keys={this.target}
                    filterable
                    on-on-change={v => (this.target = v)}
                />
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertAddStationModal(id: number, parentId: number, isPlatform?: boolean): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<AddStationVOI.PropsI>(AddStationModal)({
            id,
            parentId,
            isPlatform,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
